import React from "react";

const OfficeLocations = () => {
  // Data structure for offices to keep code clean
  const offices = [
    {
      id: 1,
      title: "Mazar-e-Sharif, Afghanistan",
      address: "Shohadi Iran Street, Mazar-i-Sharif",
      email: "contact@yarqinhub.com",
      phone: "+93 78 841 4348",
      isMain: true, // You can use this to highlight HQ
    },
    {
      id: 2,
      title: "Termiz, Uzbekistan",
      address:
        "Surxondaryo Region, Termiz City, 5th Microdistrict, 42nd House, 34th Room",
      email: "info@yth.itpark.com",
      phone: "+998 99 141 43 48",
      isMain: false,
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* --- Section Header --- */}
        <div className="max-w-2xl mx-auto text-center mb-16">
          <span className="inline-block py-1 px-3 rounded-full bg-blue-50 text-blue-600 text-sm font-semibold tracking-wide uppercase mb-4">
            Find Us
          </span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-slate-900 tracking-tight mb-4">
            Office Locations
          </h2>
          <p className="text-lg text-slate-600 leading-relaxed">
            Whether you call, email, or chat with us, you’ll connect with our
            knowledgeable, friendly, and in-house team across our regional
            offices.
          </p>
        </div>

        {/* --- Grid Layout: Map (Left/Top) + Info (Right/Bottom) --- */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12 items-start">
          {/* --- Map Section (Takes 2 columns on desktop) --- */}
          <div className="lg:col-span-2 w-full h-[400px] md:h-[500px] rounded-2xl overflow-hidden shadow-2xl border border-slate-200">
            {/* NOTE: Update the 'src' URL below to your actual map embed */}
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2383.541522891018!2d67.11172192372821!3d36.708099054335115!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3f34b9395d7a4e73%3A0x39462a13d3bca1dc!2sYarqin%20Tech%20Hub!5e0!3m2!1sen!2s!4v1768822566621!5m2!1sen!2s"
              width="100%"
              height="100%"
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>

          {/* --- Contact Info Panel (Takes 1 column on desktop) --- */}
          <div className="lg:col-span-1 space-y-8">
            {offices.map((office) => (
              <div key={office.id} className="relative">
                {/* Office Card */}
                <div
                  className={`p-6 rounded-2xl border ${
                    office.isMain
                      ? "border-blue-100 bg-blue-50/50"
                      : "border-slate-100 bg-white shadow-sm"
                  }`}
                >
                  {/* Header */}
                  <div className="flex items-center justify-between mb-4">
                    <h3 className="text-xl font-bold text-slate-900">
                      {office.title}
                    </h3>
                    {office.isMain && (
                      <span className="px-2 py-1 text-xs font-bold text-blue-700 bg-blue-100 rounded uppercase tracking-wider">
                        HQ
                      </span>
                    )}
                  </div>

                  {/* Address */}
                  <div className="mb-6">
                    <p className="text-slate-600 text-sm leading-relaxed">
                      {office.address}
                    </p>
                  </div>

                  <div className="w-full h-px bg-slate-200 my-4"></div>

                  {/* Contact Details */}
                  <div className="space-y-3">
                    {/* Email */}
                    <div className="flex items-start gap-3">
                      <div className="mt-1 text-blue-600">
                        <svg
                          className="w-5 h-5"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                          />
                        </svg>
                      </div>
                      <div>
                        <p className="text-xs text-slate-400 font-semibold uppercase">
                          Email
                        </p>
                        <a
                          href={`mailto:${office.email}`}
                          className="text-sm font-bold text-slate-900 hover:text-blue-600 transition-colors"
                        >
                          {office.email}
                        </a>
                      </div>
                    </div>

                    {/* Phone */}
                    <div className="flex items-start gap-3">
                      <div className="mt-1 text-blue-600">
                        <svg
                          className="w-5 h-5"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                          />
                        </svg>
                      </div>
                      <div>
                        <p className="text-xs text-slate-400 font-semibold uppercase">
                          Phone
                        </p>
                        <a
                          href={`tel:${office.phone}`}
                          className="text-sm font-bold text-slate-900 hover:text-blue-600 transition-colors"
                        >
                          {office.phone}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default OfficeLocations;
